import styled from 'styled-components'
import Modal, { ModalContentWrapper } from 'components/Modal'

export const ModalContainer = styled(Modal)`
  .Overlay {
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 2;
  }

  ${ModalContentWrapper} {
    width: fit-content;
  }
`
